export default "__VITE_ASSET__CwQC7fNb__"